import { ChakraBadge } from '@equip.health/ui';

import PatientTableCellToolTip from '~/components/common/PatientTableCellToolTip';

interface BadgeProps {
  bgColor: string;
  id: string;
  label: string;
  labelColor: string;
}

export const SurveyBadge = ({ bgColor, id, label, labelColor }: BadgeProps) => (
  <PatientTableCellToolTip content={label} id={id}>
    <ChakraBadge
      as="span"
      background={bgColor}
      borderRadius="full"
      color={labelColor}
      fontWeight="700"
      id={id}
      overflow="hidden"
      padding="2px 8px"
      textOverflow="ellipsis"
      textTransform="none"
      whiteSpace="nowrap"
    >
      {label}
    </ChakraBadge>
  </PatientTableCellToolTip>
);
